import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/accessibility")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: DICTS.en["legal.accessibility.meta.title"] },
      { name: "description", content: DICTS.en["legal.accessibility.meta.description"] },
      { property: "og:title", content: DICTS.en["legal.accessibility.meta.title"] },
      { property: "og:description", content: DICTS.en["legal.accessibility.meta.description"] },
      { property: "og:url", content: `${PUBLIC_SITE_ORIGIN}/accessibility` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: `${PUBLIC_SITE_ORIGIN}/accessibility` }],
  }),
  component: AccessibilityPage,
});

function AccessibilityPage() {
  const { t } = useLocale();
  return (
    <LegalLayout
      titleKey="legal.accessibility.title"
      eyebrowKey="legal.accessibility.eyebrow"
    >
      <p>{t("legal.accessibility.intro")}</p>
      <h2>{t("legal.accessibility.h2_features")}</h2>
      <p>{t("legal.accessibility.p_features")}</p>
      <h2>{t("legal.accessibility.h2_limits")}</h2>
      <p>{t("legal.accessibility.p_limits")}</p>
      <h2>{t("legal.accessibility.h2_help")}</h2>
      <p>{t("legal.accessibility.p_help")}</p>
      <h2>{t("legal.accessibility.h2_feedback")}</h2>
      <p>{t("legal.accessibility.p_feedback")}</p>
    </LegalLayout>
  );
}
